import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import NavBar from "../Comp/NavBar";
import Footer from "../Comp/Footer";
import Item from "../Comp/ProductList/Item";

const API = process.env.REACT_APP_API_BASE_URL;

// Round-robin categories across their product type so the homepage isn't a wall
// of appliances. First-14-by-id was all appliances (A-D); kids' 135 categories
// never appeared.
function interleaveByType(cats, perGroup) {
  const groups = {};
  cats.forEach((c) => {
    (groups[c.item_type_id] = groups[c.item_type_id] || []).push(c);
  });
  Object.values(groups).forEach((g) => g.sort((a, b) => (a.name || "").localeCompare(b.name || "")));
  const out = [];
  for (let i = 0; i < perGroup; i++) {
    Object.values(groups).forEach((g) => { if (g[i]) out.push(g[i]); });
  }
  return out;
}

const Home = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);

  useEffect(() => {
    axios.get(`${API}/Public/getCategories`)
      .then((r) => setCats(r.data || [])).catch(() => {});

    // Featured = a few from each product type, so kids and appliances both show.
    // Uses the paged endpoint (a handful of rows) instead of pulling all 2.4k.
    axios.get(`${API}/Public/getTypes`)
      .then((r) => {
        const types = r.data || [];
        return Promise.all(
          types.map((t) =>
            axios
              .get(`${API}/Public/getItemsPage`, { params: { type_id: t.id, limit: 6 } })
              .then((res) => (res.data && res.data.items) || [])
              .catch(() => [])
          )
        );
      })
      .then((lists) => {
        // interleave one-from-each-type so the row alternates
        const out = [];
        const max = Math.max(0, ...lists.map((l) => l.length));
        for (let i = 0; i < max; i++) lists.forEach((l) => { if (l[i]) out.push(l[i]); });
        setItems(out.slice(0, 12));
      })
      .catch(() => {});
  }, []);

  const openCategory = (c) => navigate("/Category", { state: { category_id: c.id } });

  const chips = interleaveByType(cats, 8).slice(0, 16);

  return (
    <div>
      <NavBar />

      <section className="oot-hero">
        <div className="oot-hero-inner">
          <h1>Everything your home &amp; family needs — in one place.</h1>
          <p>Shop appliances, home essentials and kids' favourites from trusted local stores, delivered across Lebanon.</p>
          <button className="oot-btn oot-btn-lg" onClick={() => navigate("/Category")}>Start shopping</button>
        </div>
      </section>

      {chips.length > 0 && (
        <section className="oot-section">
          <div className="oot-section-head">
            <h2>Shop by category</h2>
            <a onClick={() => navigate("/Category")}>View all</a>
          </div>
          <div className="oot-chips">
            {chips.map((c) => (
              <button key={c.id} className="oot-chip" onClick={() => openCategory(c)}>{c.name}</button>
            ))}
          </div>
        </section>
      )}

      <section className="oot-section" style={{ paddingTop: 0 }}>
        <div className="oot-section-head">
          <h2>Featured products</h2>
          <a onClick={() => navigate("/Category")}>See all</a>
        </div>
        <div className="oot-grid">
          {items.map((it) => (<Item key={it.id} data={it} />))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;
